import React from "react";
import Header from "./Header";
import InvestmentImageOne from "../img/rectangle-6518@2x.svg"
import BaseContainerDividingLineRHSSidebar from "./BaseContainerDividingLineRHSSidebar";
import right12 from "../img/right-12@2x.svg";
import RegisteredButton from "./RegisteredButton";
import NonRegisteredButton from "./NonRegisteredButton";
import ExpandTFSAButton from "./ExpandTFSAButton";
import ExpandRRSPButton from "./ExpandRRSPButton";
import ExpandLIRAButton from "./ExpandLIRAButton";
import ExpandRRIFButton from "./ExpandRRIFButton";
import ExpandLIFButton from "./ExpandLIFButton";
import logo from "../img/group-6@2x.svg";
import "./Investments.css";

const Investments = () => {
    return(
        <div className="container-center-horizontal">
            <div className="investments-home-page screen">
                <div className="flex-col-24">
                    <Header />
                    <div className="overlap-group3-3">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="investments-8 nunito-bold-black-30px">Investments</div>
                        <img className="rectangle-7005" src={InvestmentImageOne} />
                        <div className="rectangle-6457-1 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6458 border-1px-athens-gray-2"></div>
                        <div className="change-plan">
                            <div className="change-plan-1 nunito-bold-black-20px">Registered</div>
                        </div>
                        <ExpandLIRAButton />
                        <ExpandRRSPButton />
                        <ExpandRRIFButton />
                        <ExpandLIFButton />
                        <ExpandTFSAButton />
                        <img className="right-26" src={right12} />

                        <img className="right-27" src={right12} />
                        <img className="right-28" src={right12} />
                        <img className="right-29" src={right12} />

                        <img className="right-30" src={right12} />
                        <RegisteredButton className="nunito-bold-azure-radiance-14px" handLogo={logo} />
                        <NonRegisteredButton />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Investments;